<template>
  <div class="sidebar__block sidebar__block--green">
    <div>{{scope}}</div>
    <div>В пути</div>
  </div>
</template>

<script>
export default {
  name: "scope_onpay",
  data: function(){
    return {scope: this.$parent.scope }
  }
}
</script>

<style scoped>

</style>